const actionTypes = {
    FETCH_PAYMENT_METHODS: 'FETCH_PAYMENT_METHODS',
    FETCH_SHIPPING_METHODS: 'FETCH_SHIPPING_METHODS',
    ADD_CHECKOUT_ADDRESS: 'ADD_CHECKOUT_ADDRESS',
    ADD_SHIPPMENT_METHOD: 'ADD_SHIPPMENT_METHOD',
    ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
    ADD_COMPLETE_CHECKOUT: 'ADD_COMPLETE_CHECKOUT',
    ADD_ORDER_INFO: 'ADD_ORDER_INFO',
    ADD_ORDERS: 'ADD_ORDERS',
    ADD_PAYMENT_INFO: 'ADD_PAYMENT_INFO',
    PAY_FOR_ORDER: 'PAY_FOR_ORDER',
};

export { actionTypes };
